export default __webpack_public_path__ + "static/media/art-red-poster-1.ec4b54ed.jpg";